import { fmtHUF } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

const TIERS = [
  { key: "desk_hour",    label: "Asztal",   unit: "óra",   price: 1500,  desc: "Egy gyors meeting vagy mély-fókuszú óra. Foglalj kávéval.", featured: false },
  { key: "desk_day",     label: "Asztal",   unit: "nap",   price: 5000,  desc: "Egész napos jelenlét, kötöttségek nélkül. 8:00–20:00.", featured: false },
  { key: "desk_month",   label: "Asztal",   unit: "hónap", price: 30000, desc: "Saját ritmus, fix asztal, korlátlan belépés.", featured: true },
  { key: "meeting_hour", label: "Tárgyaló", unit: "óra",   price: 6000,  desc: "Diszkrét, 4–6 fős tárgyaló kijelzővel és tablóval.", featured: false },
  { key: "office_day",   label: "Egész iroda", unit: "nap", price: 30000, desc: "A teljes coworking-tér kizárólag a csapatodnak.", featured: true },
];

const goto = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Services() {
  return (
    <section
      id="szolgaltatasok"
      data-testid="services-section"
      className="py-24 md:py-32 bg-white border-y border-[#E5E0D8]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 mb-16 lg:mb-20 items-end gap-8">
          <div className="lg:col-span-8">
            <p className="eyebrow mb-6">Szolgáltatások & Árak</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A1A1A]">
              Foglalási lehetőségek<br /><span className="italic">minden léptékben.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 text-[#595959] text-[15px] leading-relaxed">
            Az árak bruttóban értendők. Nincs előleg, fizetés a helyszínen vagy átutalással.
            Csapatban vagytok? Kérj egyedi ajánlatot a kapcsolati űrlapon.
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E0D8]">
          {TIERS.map((t, i) => (
            <article
              key={t.key}
              data-testid={`service-card-${t.key}`}
              className={`relative p-8 md:p-10 bg-white group hover:bg-[#FAF9F6] transition-colors duration-500 ${
                t.featured ? "lg:row-span-1" : ""
              }`}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="eyebrow">{`0${i + 1}`}</span>
                {t.featured && (
                  <span className="eyebrow text-[#C5A059]" data-testid={`featured-${t.key}`}>Népszerű</span>
                )}
              </div>
              <h3 className="font-serif-display text-3xl md:text-4xl text-[#1A1A1A] leading-tight">
                {t.label}
                <span className="block italic text-[#BFA588] text-2xl mt-1">/ {t.unit}</span>
              </h3>
              <div className="mt-8 mb-6">
                <span className="font-serif-display text-5xl md:text-6xl text-[#1A1A1A]">
                  {fmtHUF(t.price)}
                </span>
              </div>
              <p className="text-[#595959] text-[15px] leading-relaxed min-h-[64px]">
                {t.desc}
              </p>
              <button
                onClick={() => goto("foglalas")}
                data-testid={`service-book-${t.key}`}
                className="mt-8 inline-flex items-center gap-2 text-[12px] tracking-[0.25em] uppercase text-[#1A1A1A] border-b border-[#1A1A1A] pb-1 hover:gap-3 hover:text-[#BFA588] hover:border-[#BFA588] transition-all duration-300"
              >
                Foglalás <ArrowUpRight className="w-4 h-4" />
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
